import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import moment from "moment";
import { Button, DropdownButton, MenuItem } from "react-bootstrap";
import DashboardDeviceHealth from "../DashboardDeviceHealth";
import DashboardActionCount from "../DashboardActionCount";
import DashboardActionCountMap from "../DashboardActionCountMap";
import DashboardNotes from "../DashboardNotes";
import DashboardRimgCounter from "../DashboardRimgCounter";
import NoteSmallIcon from "../../_icons/NoteSmallIcon";
import { history } from "../../_helpers";
import _ from "lodash";
import "./index.css";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      selectedPrecinct: null,
      allPrecinct: { id: 0, name: "All precincts" },
      // should set by api return, set it to null when api is ready.
      lastUpdateTime: null,
      reloadTimer: null,
      reloadCount: 0,
      alertCountChart: true
    };
  }

  componentDidMount = () => {
    const dashboardPrecinct = JSON.parse(localStorage.getItem("dashboardPrecinct"));

    const configList = this.props.configList;
    if (configList && configList.precincts && configList.permissions) {
      const permissions = configList.permissions.statistics;
      this.presetPrecinct(dashboardPrecinct, configList, permissions);
      this.setState({
        permissions: permissions[0]
      });
    }
    // set counter to refresh all component every 30 second.
    if (this.state.reloadTimer === null) {
      const reloadTimer = setInterval(this.reloadDashboard, 120000);
      this.setState({ reloadTimer: reloadTimer });
    }
    // set alert count chart or map base on stored view.
    const alertCountChart = JSON.parse(localStorage.getItem("alertCountChart"));
    if (alertCountChart !== null) {
      this.setState({ alertCountChart: alertCountChart });
    }
  };

  componentWillReceiveProps = nextProps => {
    if (JSON.stringify(this.props.configList) !== JSON.stringify(nextProps.configList)) {
      const dashboardPrecinct = JSON.parse(localStorage.getItem("dashboardPrecinct"));
      const permissions = nextProps.configList.permissions.statistics;
      this.presetPrecinct(dashboardPrecinct, nextProps.configList, permissions);
      this.setState({
        permissions: permissions[0]
      });
    }
  };

  componentWillUnmount = () => {
    // clear the interval on unmount.
    clearInterval(this.state.reloadTimer);
  };

  presetPrecinct = (dashboardPrecinct, configList, permissions) => {
    const precinctList = configList.precincts;
    let filterdPrecinctList = [];
    // filter precincts list using config permissions.
    if (permissions && permissions[0].precincts) {
      filterdPrecinctList = _.filter(precinctList, function (p) {
        return _.includes(permissions[0].precincts, p.id);
      });
      this.setState({ filterdPrecinctList: filterdPrecinctList });
    }
    // set preset precinct.
    if (dashboardPrecinct) {
      // set precinct if localstorage has preset precinct.
      // if no permission to can_access_project_wide_stats but localstorage was set to all precinct.
      if (dashboardPrecinct.id === 0 && !permissions[0].can_access_project_wide_stats) {
        this.setSelectedPrecinct(filterdPrecinctList, permissions[0].precincts[0], permissions[0]);
        // clear localStorage.
        localStorage.removeItem("dashboardPrecinct");
      } else {
        if (permissions[0].can_access_project_wide_stats && filterdPrecinctList.length === 0) {
          // set to all precinct if has permission and `filterdPrecinctList` is empty.
          this.setSelectedPrecinct(filterdPrecinctList, 0, permissions[0]);
          // clear localStorage.
          localStorage.removeItem("dashboardPrecinct");
        } else {
          this.setSelectedPrecinct(filterdPrecinctList, dashboardPrecinct.id, permissions[0]);
        }
      }
    } else if (permissions[0].can_access_project_wide_stats) {
      // set precinct to all precinct if no stored and have permission to see wide stats.
      this.setSelectedPrecinct(filterdPrecinctList, 0, permissions[0]);
    } else {
      // set precinct to first item of the list.
      this.setSelectedPrecinct(filterdPrecinctList, permissions[0].precincts[0], permissions[0]);
    }
  };

  // reload the dashboard
  reloadDashboard = () => {
    const { user } = this.props;
    // check if user session is expired in every refresh of data.
    const exp = moment(user.expiresAt).subtract(30, "m");
    const tokenExpired = moment().isAfter(exp);
    if (tokenExpired) {
      history.push("/login");
    } else {
      this.setState({
        reloadCount: this.state.reloadCount + 1,
        lastUpdateTime: moment()
      });
    }
  };

  setSelectedPrecinct = (precinctList, precinctID, permissions) => {
    // check if saved precinct exist
    if (precinctID) {
      const precinct = _.find(precinctList, item => {
        return item.id === Number(precinctID);
      });
      if (!precinct) {
        localStorage.removeItem("dashboardPrecinct");
      }
      const presetPrecinct = permissions.can_access_project_wide_stats ? this.state.allPrecinct : precinctList[0];
      this.setState({
        selectedPrecinct: precinct ? precinct : presetPrecinct,
        lastUpdateTime: moment()
      });
    } else if (precinctID === 0) {
      this.setState({
        selectedPrecinct: this.state.allPrecinct,
        lastUpdateTime: moment()
      });
    }
  };

  setPrecinct = e => {
    this.setState({
      selectedPrecinct: e,
      lastUpdateTime: moment()
    });
    // set selected precinct to localStorage.
    localStorage.setItem("dashboardPrecinct", JSON.stringify(e));
  };

  refreshDashboard = () => {
    // refresh dashboard.
    this.reloadDashboard();
    clearInterval(this.state.reloadTimer);
    const reloadTimer = setInterval(this.reloadDashboard, 120000);
    this.setState({ reloadTimer: reloadTimer });
  };

  toggleActionCount = () => {
    this.setState({
      alertCountChart: !this.state.alertCountChart
    });
    localStorage.setItem("alertCountChart", !this.state.alertCountChart);
  };

  renderPrecinctsDropdown() {
    const { selectedPrecinct, permissions, filterdPrecinctList } = this.state;
    if (filterdPrecinctList) {
      return (
        <DropdownButton
          title={selectedPrecinct ? selectedPrecinct.name : ""}
          id="precincts-dropdown"
          className="precincts-dropdown"
          onSelect={e => this.setPrecinct(e)}
        >
          {permissions &&
            permissions.can_access_project_wide_stats && (
              <MenuItem eventKey={{ id: 0, name: "All precincts" }}>All precincts</MenuItem>
            )}
          {filterdPrecinctList.map(precinct => {
            return (
              <MenuItem key={precinct.id} eventKey={precinct}>
                {precinct.name}
              </MenuItem>
            );
          })}
        </DropdownButton>
      );
    } else {
      return null;
    }
  }

  renderMainTitle = () => {
    const { configList } = this.props;
    let observationButton;

    if (!configList.permissions.observations || configList.permissions.observations.length < 1) {
      observationButton = null;
    } else {
      observationButton = (
        <Link to={"/createObservation"}>
          <Button bsStyle="primary" className="btn-observation">
            <NoteSmallIcon className="small-icon" stroke="#ffffff" />Log an observation
          </Button>
        </Link>
      );
    }

    return (
      <div className="mainTitle clearfix">
        {this.renderPrecinctsDropdown()}
        <div className="pull-right btnConDashboard hidden-xs">
          <div className="dashboardCon">{observationButton}</div>
          <div className="dashboardCon">
            <Button bsStyle="primary" onClick={() => this.refreshDashboard()}>
              Refresh
            </Button>
          </div>
        </div>
        <div className="hidden-md hidden-lg hidden-sm btnConDashboard">{observationButton}</div>
      </div>
    );
  };

  renderLastUpdateTime = () => {
    const { lastUpdateTime } = this.state;
    if (lastUpdateTime) {
      return (
        <div className="text-center margin-btm">
          <strong>Last Updated: </strong>
          {lastUpdateTime.format("DD MMMM YYYY, hh:mm a")}
        </div>
      );
    } else {
      return null;
    }
  };

  render() {
    const { configList } = this.props;
    const { selectedPrecinct, reloadCount, permissions, alertCountChart } = this.state;
    if (!configList && !permissions) {
      return null;
    }
    return (
      <div className={"dashboardManagement"}>
        {this.renderMainTitle()}
        <div className="card-panel">
          {permissions &&
            permissions.can_access_device_health_stats && (
              <DashboardDeviceHealth currentPrecinct={selectedPrecinct} reloadCount={reloadCount} />
            )}
          {permissions &&
            permissions.can_access_alert_stats &&
            alertCountChart && (
              <DashboardActionCount
                currentPrecinct={selectedPrecinct}
                reloadCount={reloadCount}
                toggleFunction={this.toggleActionCount}
              />
            )}
          {permissions &&
            permissions.can_access_alert_stats &&
            !alertCountChart && (
              <DashboardActionCountMap
                currentPrecinct={selectedPrecinct}
                reloadCount={reloadCount}
                toggleFunction={this.toggleActionCount}
              />
            )}
          {permissions &&
            permissions.can_access_note_stats && (
              <DashboardNotes currentPrecinct={selectedPrecinct} reloadCount={reloadCount} />
            )}
          {permissions &&
            permissions.can_access_rimg_stats && (
              <DashboardRimgCounter currentPrecinct={selectedPrecinct} reloadCount={reloadCount} />
            )}
        </div>
        {this.renderLastUpdateTime()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { notePermission } = state.note;
  const { user } = state.authentication;
  const { configList } = state.configuration;
  return {
    user,
    notePermission,
    configList
  };
}

export default connect(mapStateToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/_components/Dashboard/index.js